module.exports = __webpack_public_path__ + "img/report-icon-dark.d0cf5452.svg";